import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hybse-admin-create-demo-markets',
  templateUrl: './create-demo-markets.component.html',
  styleUrls: ['./create-demo-markets.component.css']
})
export class CreateDemoMarketsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/demo-company/demo-markets/create-demo-markets/create-demo-markets.component.ts